import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card_title, { class: "title font-weight-regular justify-space-between" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString("Veuillez préciser le moyen de paiement du montant de " +
                _ctx.newCommonFormatCurrency(_ctx.totalPersonalisedAmountSigned, undefined)) + " ", 1),
        (_ctx.step)
          ? (_openBlock(), _createBlock(_component_v_avatar, {
              key: 0,
              color: "primary-lighten-2",
              class: "subheading white--text",
              size: "24"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.step), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_v_card_text, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select_filled, {
                  modelValue: _ctx.paymentType,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.paymentType) = $event)),
                  items: _ctx.paymentTypes,
                  "item-value": "value",
                  label: "Type de paiement",
                  density: "compact",
                  "item-title": (item) => item.text
                }, null, 8, ["modelValue", "items", "item-title"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field_filled, {
                  label: _ctx.paymentType === 'CHEQUE' ? 'Numéro de chèque*' : 'Description*',
                  modelValue: _ctx.description,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.description) = $event)),
                  rules: [
                            (v) =>
                                v.length >= 3 ||
                                (_ctx.paymentType === 'CHEQUE'
                                    ? 'Numéro de chèque requis'
                                    : 'Description requise'),
                        ],
                  "data-cy": "CheckImport-numero",
                  density: "compact"
                }, null, 8, ["label", "modelValue", "rules"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: _ctx.needsBankAccount ? 6 : 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_oss_date_picker_filled, {
                  modelValue: _ctx.date,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.date) = $event)),
                  label: "Date",
                  textFieldReadOnly: false,
                  prefixDataCy: "Remittance-"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["cols"]),
            (_ctx.needsBankAccount)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 0,
                  cols: "6"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.bankAccountId,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.bankAccountId) = $event)),
                      items: _ctx.bankAccounts,
                      "item-value": "id",
                      label: "Compte bancaire utilisé ?",
                      "data-cy": "Remittance-bankAccountId",
                      density: "compact",
                      "item-title": (item) => item.name
                    }, null, 8, ["modelValue", "items", "item-title"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (!_ctx.actions)
      ? (_openBlock(), _createBlock(_component_v_card_actions, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              rounded: "",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.cancel())),
              class: "mx-auto",
              size: "small"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.step ? "Précédent" : "Annuler"), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_spacer),
            _createVNode(_component_v_btn, {
              rounded: "",
              onClick: _ctx.validate,
              loading: _ctx.loading,
              size: "small"
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode(" Oui, je suis sûr(e) ")
              ])),
              _: 1
            }, 8, ["onClick", "loading"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}